import { pageNumberState } from "@/atoms/order/page-number-state";
import { DEBOUNCE_TIME } from "@/common/constant/debounce-time";
import { initPage } from "@/common/constant/init-page";
import { PaginationSize } from "@/common/enum/pagination-size";
import { AdminAdminHeader } from "@/components/header/AdminAdminHeader";
import { AdminListTable } from "@/components/table/admin-list-table/AdminListTable";
import { AdminMyTable } from "@/components/table/admin-my-table/AdminMyTable";
import { PageWrapper } from "@/components/wrapper/PageWrapper";
import { userService } from "@/services/user-service";
import { BasePageDto } from "@/types/dto/base-page-dto";
import { UserDto } from "@/types/dto/user-dto";
import { GetAdminPagePayload } from "@/types/payload/get-admin-page-payload";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { useRecoilState } from "recoil";

export default function AdminListPage() {
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const [selectedUser, setSelectedUser] = useState<UserDto | undefined>(
    undefined
  );

  const [page, setPage] = useState<BasePageDto<UserDto>>(initPage);
  const [user, setUser] = useState<UserDto | undefined>(undefined);

  const getUser = async () => {
    try {
      const getMeResponse = await userService.getMe();
      if (!getMeResponse.ok) {
        return;
      }
      setUser(getMeResponse.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getPage = async (input: GetAdminPagePayload) => {
    try {
      const getAdminPageResponse = await userService.getAdminPage(input);
      console.log(getAdminPageResponse.data);

      setPage(getAdminPageResponse.data);
    } catch (error) {
      console.log(error);
    }
  };

  const [pageNumber, setPageNumber] = useRecoilState(pageNumberState);

  const getPageDebounce = useCallback(
    debounce(async (input) => {
      await getPage(input);
    }, DEBOUNCE_TIME),
    []
  );

  useEffect(() => {
    const payload = {
      page: pageNumber,
      size: PaginationSize.SIZE_10,
    };
    getPageDebounce(payload);
  }, [pageNumber]);

  useEffect(() => {
    getUser();
  }, []);

  const handlePageChange = (currentPage: number) => {
    setPage({ ...page, currentPage });
  };

  const openModal = (user?: UserDto) => {
    setIsOpenModal(true);
    setSelectedUser(user);
  };

  return (
    <PageWrapper>
      <div className="flex flex-col w-[1648px] h-full items-between justify-start">
        {user && (
          <>
            <AdminAdminHeader openModal={openModal} />
            <div className="flex flex-col gap-[36px]">
              <AdminMyTable user={user} />
              <AdminListTable page={page} handlePageChange={handlePageChange} />
            </div>
          </>
        )}
      </div>
    </PageWrapper>
  );
}
